<template>
  <div style="padding: 20px">
    <el-card>
      <template #header>雷达报告查看</template>
      <el-form :inline="true" @submit.prevent>
        <el-form-item label="关系ID">
          <el-input v-model="relationId" placeholder="mentor_apprentice.id" style="width:200px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="load" :disabled="!relationId">查询</el-button>
        </el-form-item>
      </el-form>

      <el-empty v-if="!list.length" description="暂无雷达数据" />

      <template v-if="latest">
        <el-descriptions title="最新评估" border style="margin-bottom:12px">
          <el-descriptions-item label="周期">{{ latest.assessmentPeriod || '-' }}</el-descriptions-item>
          <el-descriptions-item label="总分">{{ latest.totalScore }}</el-descriptions-item>
          <el-descriptions-item label="健康类型">
            <el-tag :type="healthTag(latest.healthType)">{{ healthText(latest.healthType) }}</el-tag>
          </el-descriptions-item>
        </el-descriptions>

        <div class="radar-wrap">
          <svg viewBox="0 0 240 240" width="260" height="260">
            <polygon :points="grid(1)" class="grid" />
            <polygon :points="grid(0.66)" class="grid" />
            <polygon :points="grid(0.33)" class="grid" />
            <line v-for="(p,i) in axis" :key="'a'+i" :x1="cx" :y1="cy" :x2="p.x" :y2="p.y" class="axis" />
            <text v-for="(p,i) in axis" :key="'t'+i" :x="p.tx" :y="p.ty" class="axis-label">{{ axes[i] }}</text>
            <polygon :points="valuePoints" class="val" />
          </svg>
        </div>

        <el-table :data="list" border style="margin-top:12px">
          <el-table-column prop="assessmentPeriod" label="周期" />
          <el-table-column prop="learningScore" label="学习成长" />
          <el-table-column prop="influenceScore" label="影响力" />
          <el-table-column prop="funScore" label="乐趣" />
          <el-table-column prop="rewardScore" label="回报" />
          <el-table-column prop="totalScore" label="总分" />
          <el-table-column label="健康">
            <template #default="{row}"><el-tag :type="healthTag(row.healthType)">{{ healthText(row.healthType) }}</el-tag></template>
          </el-table-column>
        </el-table>
      </template>
    </el-card>
  </div>
</template>

<script>
import { mentorRadar } from '@/api/mentor'

export default {
  name: 'MentorRadarView',
  data () {
    return {
      relationId: this.$route.query.relationId || '',
      list: [],
      axes: ['学习成长', '影响力', '乐趣', '回报'],
      cx: 120, cy: 120, r: 86
    }
  },
  computed: {
    latest () { return this.list[0] || null },
    axis () {
      const pts = []
      for (let i = 0; i < 4; i++) {
        const ang = -Math.PI / 2 + i * Math.PI / 2
        pts.push({ x: this.cx + this.r * Math.cos(ang), y: this.cy + this.r * Math.sin(ang),
                   tx: this.cx + (this.r + 14) * Math.cos(ang), ty: this.cy + (this.r + 14) * Math.sin(ang) + 4 })
      }
      return pts
    },
    valuePoints () {
      const scores = this.latest ? [this.latest.learningScore, this.latest.influenceScore, this.latest.funScore, this.latest.rewardScore] : [0,0,0,0]
      return scores.map((s, i) => {
        const ang = -Math.PI / 2 + i * Math.PI / 2
        const v = Math.min(Number(s || 0), 10) / 10
        return (this.cx + this.r * v * Math.cos(ang)) + ',' + (this.cy + this.r * v * Math.sin(ang))
      }).join(' ')
    }
  },
  mounted () { if (this.relationId) this.load() },
  methods: {
    async load () {
      const r = await mentorRadar({ relationId: Number(this.relationId) })
      if (r && r.code === 200) this.list = r.data || []
      else this.list = []
    },
    grid (scale) {
      const pts = []
      for (let i = 0; i < 4; i++) {
        const ang = -Math.PI / 2 + i * Math.PI / 2
        pts.push((this.cx + this.r * scale * Math.cos(ang)) + ',' + (this.cy + this.r * scale * Math.sin(ang)))
      }
      return pts.join(' ')
    },
    healthText (t) { return t === 2 ? '全面预警' : t === 1 ? '结构性失衡' : '全面健康' },
    healthTag (t) { return t === 2 ? 'danger' : t === 1 ? 'warning' : 'success' }
  }
}
</script>

<style scoped>
.radar-wrap { display: flex; justify-content: center; padding: 12px 0; }
.grid { fill: none; stroke: #eee; }
.axis { stroke: #ddd; }
.axis-label { font-size: 11px; fill: #666; text-anchor: middle; }
.val { fill: rgba(64,158,255,0.25); stroke: #409eff; stroke-width: 2; }

/* 清爽简约风 */
:deep(.el-card) { border-radius: 12px; box-shadow: 0 2px 8px rgba(31, 45, 61, .08); }
:deep(.el-card__header) { font-weight: 600; background: #fafbfc; border-radius: 12px 12px 0 0; }
:deep(.el-button) { border-radius: 6px; }
</style>
